// ============================================================================
// Centralized Pipeline Step Configuration
// Single source of truth for all pipeline step definitions
// ============================================================================

export type PipelineStep =
  | "categorizationStep"
  | "propertyExtractionStep"
  | "apiFetchStep"
  | "presentationStep"
  | "generateActionsStep"
  | "evalStep";

export interface StepConfig {
  label: string;
  /** Variable name prefix for template syntax (e.g., "categorization" -> $categorization.field) */
  templateVariableName?: string;
}

export const PIPELINE_STEPS: Record<PipelineStep, StepConfig> = {
  categorizationStep: {
    label: "Categories",
    templateVariableName: "categorization",
  },
  propertyExtractionStep: {
    label: "Properties",
    templateVariableName: "propertyExtraction",
  },
  apiFetchStep: {
    label: "API Calls",
    templateVariableName: "apiFetch",
  },
  presentationStep: {
    label: "Presentation",
    templateVariableName: "presentation",
  },
  generateActionsStep: {
    label: "Generate Actions",
    templateVariableName: "generateActions",
  },
  evalStep: {
    label: "Evaluation",
    // No templateVariableName - eval is the final step, its output is not referenced
  },
};

export const ALL_STEPS = Object.keys(PIPELINE_STEPS) as PipelineStep[];

// Helper to get label
export const getStepLabel = (step: PipelineStep): string => PIPELINE_STEPS[step].label;

// Helper to get template variable name
export const getTemplateVariableName = (step: PipelineStep): string | undefined =>
  PIPELINE_STEPS[step].templateVariableName;
